import { configureStore } from "@reduxjs/toolkit";

import reducers from "./store/reducers";

const resumeStore = configureStore({
	reducer: reducers,
	devTools: process.env.NODE_ENV !== "production",
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
			immutableCheck: false,
		}),
});

export default resumeStore;
